import { useState, useEffect } from "react";
import { extractColors } from "extract-colors";

export const useExtractPhotoColors = (avatarUrl: string) => {
  const [dominantColors, setDominantColors] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!avatarUrl) {
      setIsLoading(false);
      return;
    }

    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = avatarUrl;

    img.onload = async () => {
      try {
        const colors = await extractColors(img, {
          pixels: 40000,
          distance: 0.1,
        });

        const mainColors = colors.slice(0, 5).map((color) => color.hex);

        const defaultColors = [
          "#1f65ff",
          "#ff3b30",
          "#5ac8fa",
          "#ff9500",
          "#4cd964",
        ];

        const finalColors = [...mainColors];

        if (finalColors.length < 5) {
          for (let i = finalColors.length; i < 5; i++) {
            finalColors.push(defaultColors[i]);
          }
        }

        setDominantColors(finalColors);
        setIsLoading(false);
      } catch (error) {
        console.error("Failed to extract colors:", error);
        setIsLoading(false);
      }
    };

    img.onerror = () => {
      console.error("Failed to load avatar image");
      setIsLoading(false);
    };
  }, [avatarUrl]);

  return { dominantColors, isLoading };
};
